
import Vue from "vue";
import Component from "vue-class-component";
import { LocaleSelectorType } from "@/store/i18n.store.module";
import { i18nModule, i18nState } from "@/utils/store-acessor";

@Component({})
export default class LocaleSelector extends Vue {
  @i18nModule.Getter("locales") locales!: LocaleSelectorType[];
  @i18nModule.Getter("locale") selected!: LocaleSelectorType;

  menu: boolean = false;
  locale: LocaleSelectorType = { value: "en", text: "EN", flag: require("@/assets/images/flags/en.png") };

  mounted() {
    this.locale = this.selected;
  }

  selectLocale(newValue: LocaleSelectorType) {
    if (newValue.value !== this.locale.value) {
      i18nState.onChangeLocale(newValue);
      this.$i18n.locale = newValue.value;
      localStorage.setItem("defaultLocale", newValue.value);
      this.locale = newValue;
    }
    this.menu = false;
  }
}
